import { useState, memo, useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useSpring, animated } from '@react-spring/web'
import microApp from '@micro-zoe/micro-app'
import { Dropdown } from 'mk-pc'
import { useAppNavigate, useUser } from '@mk/core'
import { useAuth } from '@/hooks'
import DefaultHeader from '@/assets/images/default-header.png'
import LogoImage from '@/assets/images/logo.png'
import './index.scss'

/**
 * 布局页头部
 */
export const LayoutHeader = memo(({ isOpen }: { isOpen: boolean }) => {
  const navigate = useAppNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  const user = useUser()
  const { userLogout } = useAuth()
  const [keyword, setKeyword] = useState('')

  const [heightStyles, heightApi] = useSpring(() => {
    return {
      from: {
        height: 0
      },
      config: {
        duration: 200
      }
    }
  })

  const [displayStyles, displayApi] = useSpring(() => {
    return {
      from: {
        opacity: 0
      },
      config: {
        duration: 500
      }
    }
  })

  useEffect(() => {
    heightApi.start({
      to: {
        height: isOpen ? 56 : 0
      }
    })

    displayApi.start({
      to: {
        opacity: isOpen ? 1 : 0
      }
    })
  }, [isOpen])

  useEffect(() => {
    setKeyword(searchParams.get('keyword') || '')
  }, [searchParams])

  useEffect(() => {
    function dataListener(data: any) {
      console.log('全局数据：', data)
      if (data.clearKeyword) {
        setKeyword('')
      }
    }

    microApp.addGlobalDataListener(dataListener)

    return () => {
      // 解绑监听函数
      microApp.removeGlobalDataListener(dataListener)
    }
  }, [])

  /**
   * 退出
   */
  const handleLogout = async () => {
    await userLogout()

    window.location.replace('/login')
  }

  /**
   * 到主页
   */
  const toHome = () => {
    navigate('/cloud/plan', { appName: 'kbsApp', appBaseRoute: '/kbs/' })
  }

  /**
   * 跳转个人信息
   */
  const toUserCenter = () => {
    navigate('/user/info', { appName: 'osApp', isMainApp: true })
  }

  return (
    <animated.header className="layout-header" style={{ ...heightStyles, ...displayStyles }}>
      {isOpen && (
        <>
          <div className="layout-header__logo" onClick={toHome}>
            <img className="logo-image" src={LogoImage} />
          </div>
          <div className="right">
            <Dropdown
              menu={{
                items: [
                  {
                    key: 'userCenter',
                    label: (
                      <div className="user-menu-item" onClick={toUserCenter}>
                        个人中心
                      </div>
                    )
                  },
                  {
                    key: 'logout',
                    label: (
                      <div className="user-menu-item" onClick={handleLogout}>
                        退出登录
                      </div>
                    )
                  }
                ]
              }}
              overlayClassName="layout-header__menu"
            >
              <div className="user">
                <div className="avatar">
                  <img src={user?.header || DefaultHeader} />
                </div>
                <span className="name">{user?.name}</span>
              </div>
            </Dropdown>
          </div>
        </>
      )}
    </animated.header>
  )
})
